import Controller from "./application_controller"
import LazySelectController from "./lazy_select_controller"

/**
 * Makes each matching cell act as its field's input surface: clicking empty
 * cell space focuses the cell's field, so when a multi-line field grows the
 * row, clicks beside a short sibling field still focus it.
 *
 * A single delegated listener on a stable ancestor covers every matching cell,
 * so large repeated tables need no per-cell or per-row wiring, and rows added
 * after load are covered automatically.
 *
 *   <table data-controller="click-to-focus"
 *          data-click-to-focus-cell-value="tr.item:not(.selected) > td">
 *     <tr class="item"><td><input type="text"></td></tr>
 *   </table>
 *
 * Select fields are opened as well as focused, populating them first when
 * they are lazy selects.
 */
export default class extends Controller {
  static values = {
    cell: { type: String, default: "td" },
    field: { type: String, default: "input[type=text], select, textarea" }
  }

  connect() {
    this.addEventListener("click", this.onClick.bind(this))
  }

  onClick(event) {
    const cell = event.target.closest(this.cellValue)
    if (!cell || !this.element.contains(cell)) return

    const field = cell.querySelector(this.fieldValue)
    if (!field || field.contains(event.target)) return

    field.focus()
    if (field.tagName == "SELECT") this.openSelect(field)
  }

  openSelect(select) {
    // Populate a lazy select before opening it, rather than relying on the
    // focus above reaching its (possibly deferred) controller first.
    LazySelectController.populateElement(select)

    try {
      select.showPicker?.()
    } catch {
      // showPicker throws unless called from a user gesture.
    }
  }
}
